import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UzurvPipesModule } from '@uzurv/core';
import { TripRiderDetailComponent } from './trip-rider-detail.component';

@NgModule({
  declarations: [TripRiderDetailComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule, MatRippleModule, MatTooltipModule, UzurvPipesModule],
  exports: [TripRiderDetailComponent]
})
export class TripRiderDetailModule {}
